import { BASE_USDC_ADDRESS, BASE_USDC_DECIMALS } from '@/constants/limitless'
import { CHAIN_CONFIG } from '@/lib/api/relay'
import { readViemErc20Balance } from '../evm'
import type { MarketBalance, MarketWalletProvider } from '../types'

export const limitlessWalletProvider: MarketWalletProvider = {
	id: 'limitless',
	label: 'Limitless',
	direction: 'toLimitless',
	decimals: BASE_USDC_DECIMALS,
	chain: { chainId: CHAIN_CONFIG.base.id, currency: CHAIN_CONFIG.base.usdc },
	cashToken: {
		symbol: 'USDC',
		address: BASE_USDC_ADDRESS,
		decimals: BASE_USDC_DECIMALS,
	},
	resolveAddress: runtime => runtime.addressOverrides?.limitless ?? runtime.eoaAddress ?? undefined,
	balanceQueryKey: address => ['market-balance', 'limitless', address] as const,
	async readBalance(runtime): Promise<MarketBalance | null> {
		const address = this.resolveAddress(runtime)
		if (!(address && runtime.basePublicClient)) return null

		const cash = await readViemErc20Balance({
			client: runtime.basePublicClient,
			tokenAddress: BASE_USDC_ADDRESS,
			account: address as `0x${string}`,
			decimals: BASE_USDC_DECIMALS,
			symbol: 'USDC',
		})

		return { platform: 'limitless', address, cash }
	},
	async readTokenBalance(runtime, request) {
		const address = request.address ?? this.resolveAddress(runtime)
		if (!(address && runtime.basePublicClient)) return null

		return readViemErc20Balance({
			client: runtime.basePublicClient,
			tokenAddress: request.tokenAddress as `0x${string}`,
			account: address as `0x${string}`,
			decimals: request.decimals,
			symbol: request.symbol ?? 'Token',
		})
	},
}
